import { ev } from "../util";

export enum MembershipGiftMode {
    NONE = ev('NONE', 0),
    SINGLE = ev('SINGLE', 1),
    SINGLE_CHOICE = ev('SINGLE_CHOICE', 2),
    MULTIPLE = ev('MULTIPLE', 3),
}